import React from "react";
import { NavLink } from "react-router-dom";
// import BannerImage2 from '../../assets/images/career-header.jpg'
const BannerSection = () => {
  return (
    <>
      <section className="career-wrapper topPageBanner">
        <div className="max-container">
          <div className="padd-90">
            <div className="text-center">
              <h1 className="heading39px roboto-regular mb10 text-color-131415">
                <span className="roboto-bold">COME &nbsp;</span>
                JOIN US!
              </h1>

              <p className="heading16px roboto-regular mb30">
                Attracting top talent is crucial for any company, and
                BeyondLeadz is no exception!
              </p>

              <ul className="btn-sec">
                <li>
                  <NavLink
                    to={"/signup"}
                    className="common-btn-class main-btn-primary roboto-regular"
                  >
                    {" "}
                    Start Free Trial
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/contact-us"}
                    className="common-btn-class transparentBtn roboto-regular"
                  >
                    Contact us
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* <div className="grid-auto-fit align-items-center">
                            <div>
                                <h1 className="heading39px roboto-regular mb10 text-color-131415">
                                    <span className="roboto-bold">
                                        COME &nbsp;
                                    </span>
                                    JOIN US!
                                </h1>

                                <p className="heading16px roboto-regular mb30">Attracting top talent is crucial for any company, and BeyondLeadz is no exception!</p>

                                <ul className="btn-sec">
                                    <li>
                                        <NavLink to={"/signup"} className="common-btn-class main-btn-primary roboto-regular"> Start Free Trial</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to={"/contact-us"} className="common-btn-class main-btn-primary roboto-regular">Contact us</NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <img src={BannerImage2} className="img-responsive position-relative" alt="Double Your Qualified Leads" />
                            </div>
                        </div> */}
          </div>
        </div>

        <svg
          viewBox="0 0 1440 320"
          xmlns="http://www.w3.org/2000/svg"
          className="careerSvg"
        >
          <path
            d="M0,320L48,293.3C96,267,192,213,288,192C384,171,480,181,576,202.7C672,224,768,256,864,224C960,192,1056,96,1152,85.3C1248,75,1344,149,1392,186.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            fill="#F5F4FF"
            fill-opacity="1"
          ></path>
        </svg>
      </section>
    </>
  );
};
export default BannerSection;
